import React, { useState }  from 'react';
import Header from './Header';
import AboutSection from '../About/AboutSection';
import Facts from '../Shared/Facts';
import ClientReview from '../Shared/ClientReview';
import ServiceSection from '../Service/ServiceSection';
import TeamSection from '../Team/TeamSection';
import useHomepage from '../../hooks/useHomepage';
import ContactUsModal from '../Shared/ContactUsModel';

const Home = () => {
  const [show, setShow] = useState(true);
  const { data, loading, error } = useHomepage(); // 👈 fetch from Redux store

  if (loading) return <div>Loading homepage...</div>;
  if (error) return <div>Error loading homepage: {error}</div>;

  console.log('---->data---->',data);


  return (
    <div>
      <Header data={data?.main?.photos} />
      <AboutSection data={data?.about_us?.photos} />
      <Facts data={data?.features} />
      <div className="container-xxl bg-light py-5 my-5">
        <ServiceSection data={data?.service?.images} />
      </div>
      <TeamSection data={data?.our_team} />
      <ClientReview data={data?.testimonial} />
      <ContactUsModal setShow={setShow} show={show} />
    </div>
  );
};

export default Home;

